module.exports = __webpack_public_path__ + "static/media/list.inactive.d11a303f.svg";